<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="required">{{ $t('saleArea.sale') }}</label>
            <a-select
              class="ts-w-full"
              v-model="model.sale_id"
              :options="saleList"
              showSearch
              :filterOption="filterOption"
            ></a-select>
            <div class="validate" v-if="errors.has('sale_id')">
              {{ errors.first('sale_id') }}
            </div>
          </div>
        </div>
      </div>
      <div class=" ts-grid ts-grid-cols-3 ts-gap-3 ts-mb-3">
        <div>
          <ProvinceGroupCheckBoxController
            :label="$t('saleArea.province')"
            v-model="model"
            :options="provinceList"
            valueKey="province_code"
            @change="onProvinceChange"
          />
          <div class="validate" v-if="errors.has('province_code')">
            {{ errors.first('province_code') }}
          </div>
        </div>
        <div>
          <DistrictGroupCheckBoxController
            :label="$t('saleArea.district')"
            v-model="model"
            :options="districts"
            valueKey="district_code"
            @change="onDistrictChange"
          />
          <div class="validate" v-if="errors.has('district_code')">
            {{ errors.first('district_code') }}
          </div>
        </div>
        <div>
          <CommuneGroupCheckBoxController
            :label="$t('saleArea.commune')"
            v-model="model"
            :options="communes"
            valueKey="commune_list"
          />
          <div class="validate" v-if="errors.has('commune_list')">
            {{ errors.first('commune_list') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ $t('saleArea.description') }}</label>
            <textarea
              v-model="model.description"
              rows="3"
              class="form-control"
            ></textarea>
            <div class="validate" v-if="errors.has('description')">
              {{ errors.first('description') }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 ts-mt-3 text-right">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            v-if="!isUpdate"
            class="mr-2"
            color="primary"
            outline
            @click.prevent="onSaveAddNew"
            :waiting="waiting_new"
            >{{ $t('save_add_new') }}</ts-button
          >
          <ts-button
            v-if="!isUpdate"
            color="primary"
            @click.prevent="onSave"
            :waiting="waiting"
            >{{ $t('save') }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            color="primary"
            @click.prevent="onUpdate"
            :waiting="waiting"
            >{{ $t('update') }}</ts-button
          >
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import { uniq } from 'lodash'
import ProvinceGroupCheckBoxController from './components/group-checkbox-control.vue'
import DistrictGroupCheckBoxController from './components/group-checkbox-control.vue'
import CommuneGroupCheckBoxController from './components/group-checkbox-control.vue'

export default {
  name: 'companyForm',
  components: {
    ProvinceGroupCheckBoxController,
    DistrictGroupCheckBoxController,
    CommuneGroupCheckBoxController
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      districts: [],
      communes: [],
      model: {
        sa_id: 0,
        description: null,
        sale_id: null,
        province_code: [],
        district_code: [],
        commune_list: []
      }
    }
  },
  created() {
    this.setEditData()
    this.fetchResources()
  },
  computed: {
    ...mapState('sale/saleArea', ['edit_data']),
    saleList() {
      return this.$store.state.sale.saleArea.sales.map(el => ({
        value: el.user_id,
        label: el.name
      }))
    },
    provinceList() {
      return this.$store.state.sale.saleArea.provinces.map(el => ({
        value: el.province_code,
        label: el.name_en
      }))
    },
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    ...mapActions('sale/saleArea', ['getDistrict', 'getCommune', 'getVillage']),
    onSaveAddNew() {
      this.waiting_new = true
      this.errors = new Errors()
      this.$store
        .dispatch('sale/saleArea/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('sale/saleArea/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('sale/saleArea/update', {
          id: this.model.sa_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearInput() {
      this.model.sa_id = 0
      this.model.description = null
      this.model.sale_id = null
      this.model.province_code = []
      this.model.district_code = []
      this.model.commune_list = []
    },
    fetchResources() {
      this.loading = true
      this.$store.dispatch('sale/saleArea/fetchResources').finally(() => {
        this.loading = false
      })
    },
    async onProvinceChange(value) {
      this.model.district_code = []
      this.model.commune_list = []
      this.communes = []
      this.loading = true
      await this.getDistrict({
        province_codes: value
      })
        .then(response => {
          this.districts = response.data.map(el => ({
            value: el.district_code,
            label: el.d_name_en + ', ' + el.p_name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onDistrictChange(value) {
      this.model.commune_list = []
      this.loading = true
      await this.getCommune({
        district_codes: value
      })
        .then(response => {
          this.communes = response.data.map(el => ({
            value: el.commune_code,
            label: el.c_name_en + ', ' + el.d_name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.sa_id = this.edit_data.sa_id
        this.model.sale_id = this.edit_data.sale_id
        this.model.description = this.edit_data.description

        await this.onProvinceChange(
          uniq(this.edit_data.area_communes.map(el => el.province_code))
        )
        await this.onDistrictChange(
          uniq(this.edit_data.area_communes.map(el => el.district_code))
        )
        
        this.model.commune_list = this.edit_data.area_communes.map(
          el => el.commune_code
        )

        this.model.province_code = uniq(
          this.edit_data.area_communes.map(el => el.province_code)
        )
        this.model.district_code = uniq(
          this.edit_data.area_communes.map(el => el.district_code)
        )
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    filterOptionElem(input, option) {
      return (
        option.componentOptions.children[0].children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    filterOptionGroup(input, option) {
      if (option.componentOptions.children.length < 2) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        )
      }
      return false
    }
  }
}
</script>
